import React from 'react';
import { Gift, FileText, ShieldAlert } from 'lucide-react';
export function BonusesSection() {
  return <section className="bg-accent py-10 md:py-24 px-4" data-id="element-11">
      <div className="max-w-4xl mx-auto" data-id="element-12">
        <div className="text-center mb-8 md:mb-12" data-id="element-13">
          <div className="inline-flex items-center justify-center gap-2 bg-white px-4 py-1.5 rounded-full text-coral font-semibold text-sm uppercase tracking-wider mb-4 md:mb-6 shadow-sm" data-id="element-14">
            <Gift className="w-4 h-4" data-id="element-15" />
            <span data-id="element-16">Regalos Incluidos Hoy</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-text-primary" data-id="element-17">
            Herramientas prácticas para facilitar el proceso
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8" data-id="element-18">
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-border relative overflow-hidden" data-id="element-19">
            <div className="absolute top-0 right-0 bg-trust text-white text-[10px] md:text-xs font-bold px-2.5 py-1 rounded-bl-lg z-10" data-id="element-20">
              Valor: $15.00 (HOY GRATIS)
            </div>
            <div className="w-10 h-10 md:w-12 md:h-12 bg-primary rounded-xl flex items-center justify-center mb-4 md:mb-6" data-id="element-21">
              <FileText className="w-5 h-5 md:w-6 md:h-6 text-trust" data-id="element-22" />
            </div>
            <h3 className="text-lg md:text-xl font-bold text-text-primary mb-2 md:mb-3" data-id="element-23">
              Plantilla: Acuerdo Familiar de Pantallas
            </h3>
            <p className="text-text-secondary text-sm leading-relaxed" data-id="element-24">
              Un documento listo para imprimir y llenar en familia. Incluye
              cláusulas sobre horarios, zonas libres de tecnología y
              consecuencias claras. Elimina las discusiones de "yo no dije eso".
            </p>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-border relative overflow-hidden" data-id="element-25">
            <div className="absolute top-0 right-0 bg-trust text-white text-[10px] md:text-xs font-bold px-2.5 py-1 rounded-bl-lg z-10" data-id="element-26">
              Valor: $12.00 (HOY GRATIS)
            </div>
            <div className="w-10 h-10 md:w-12 md:h-12 bg-primary rounded-xl flex items-center justify-center mb-4 md:mb-6" data-id="element-27">
              <ShieldAlert className="w-5 h-5 md:w-6 md:h-6 text-trust" data-id="element-28" />
            </div>
            <h3 className="text-lg md:text-xl font-bold text-text-primary mb-2 md:mb-3" data-id="element-29">
              Checklist: Seguridad y Privacidad Básica
            </h3>
            <p className="text-text-secondary text-sm leading-relaxed" data-id="element-30">
              Una guía rápida de 2 páginas para configurar controles parentales
              básicos y ajustes de privacidad en las aplicaciones más populares
              (TikTok, Instagram, Snapchat) sin invadir su espacio.
            </p>
          </div>
        </div>
      </div>
    </section>;
}